export const fetchRequest = async (
  url,
  { method = 'GET', headers = {}, body = null, queryParams = {}, timeout = 30000 } = {},
) => {
  try {
    // Process query parameters
    const queryString = new URLSearchParams(queryParams).toString()
    const requestUrl = queryString ? `${url}?${queryString}` : url

    // Assemble request configuration
    const config = {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    }

    // Process body data
    if (body && method !== 'GET') {
      config.body = JSON.stringify(body)
    }

    // Create abort controller for timeout
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), timeout)
    config.signal = controller.signal

    // Send request
    const response = await fetch(requestUrl, config)
    clearTimeout(timeoutId)

    // Parse response
    const contentType = response.headers.get('Content-Type')
    const isJson = contentType && contentType.includes('application/json')
    const data = isJson ? await response.json() : await response.text()

    // Handle errors
    if (!response.ok) {
      throw new Error(data?.message || `HTTP error! Status: ${response.status}`)
    }

    return data
  } catch (error) {
    if (error.name === 'AbortError') {
      console.error('Request timeout:', error)
      throw new Error('Request timed out. Please try again.')
    }
    console.error('Fetch request failed:', error)
    throw error
  }
}
